export const Product = Object.freeze({
	type: {
		product: 'product',
		service: 'service',
	}
});